import _ from 'lodash';
import React from 'react';
import {useTranslation} from 'react-i18next';
import AsyncSelect from 'react-select/async';

// The "{forwardRef}" is utilized to enable functionality for the prefix, and suffix elements.
// This feature allows clicking on these elements to automatically select or focus the form control associated with them."
export const RawAsyncSelect = ({
    cacheOptions,
    closeMenuOnSelect,
    defaultOptions,
    defaultValue,
    disabled,
    isClearable,
    isLoading,
    isMulti,
    key,
    loadOptions,
    menuIsOpen,
    placeholder,
    value,
    onChange,
    // === Internal properties === ///
    components,
}) => {
    const {t} = useTranslation();

    /**
     * This function is called whenever the user selects or removes an option from the dropdown,
     * or clears the selection.
     *
     * @param {{label: string; value: any} | Array<{label: string; value: any}> | null} option
     * The option(s) selected by the user. If the user clears the selection, this will be `null`.
     *
     * @param {import('react-select').ActionMeta<any>} action
     * Provides meta data about the action that triggered the change.
     */
    const handleSelectionChanged = (option, action) => {
        _.attempt(onChange, option, action);
    };

    return (
        <AsyncSelect
            cacheOptions={cacheOptions}
            classNamePrefix="form-async-select form-select"
            closeMenuOnSelect={closeMenuOnSelect}
            components={components}
            defaultOptions={defaultOptions}
            defaultValue={defaultValue}
            isClearable={isClearable}
            isDisabled={disabled}
            isLoading={isLoading}
            isMulti={isMulti}
            key={key}
            loadOptions={loadOptions}
            menuIsOpen={menuIsOpen}
            menuPosition="fixed"
            placeholder={placeholder || t('searchableDropdown.placeholder')}
            styles={{
                menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    position: 'absolute',
                    overflow: 'visible',
                    marginTop: '4px',
                }),
                menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                    fontWeight: '400',
                    fontSize: '14px',
                }),
            }}
            value={value}
            onChange={handleSelectionChanged}
        />
    );
};
